import {
  ForgotPassword,
  Login,
  PhoneVerification,
  RecoverPassword,
  Register,
} from "components/modules/Auth";
import {
  AUTH_ROOT_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  PHONE_VERIFICATION_ROUTE,
  RECOVER_PASSWORD,
  RECOVER_JOIN_PASSWORD,
  REGISTER_ROUTE,
  REGISTER_WITH_CODE_ROUTE,
} from "./authPaths";

const authRoutesConfig = {
  path: AUTH_ROOT_ROUTE,
  children: [
    {
      path: FORGOT_PASSWORD_ROUTE,
      label: "auth.forgotPassword",
      component: ForgotPassword,
    },
    {
      path: RECOVER_PASSWORD,
      label: "auth.recoverPassword",
      component: RecoverPassword,
    },
    {
      path: RECOVER_JOIN_PASSWORD,
      label: "auth.recoverPassword",
      component: RecoverPassword,
    },
    {
      path: LOGIN_ROUTE,
      label: "auth.login",
      component: Login,
    },
    {
      path: REGISTER_ROUTE,
      label: "auth.register",
      component: Register,
    },
    {
      path: REGISTER_WITH_CODE_ROUTE,
      label: "auth.registerWithCode",
      component: Register,
    },
    {
      path: PHONE_VERIFICATION_ROUTE,
      label: "auth.phoneVerification",
      component: PhoneVerification,
    },
  ],
};

export default authRoutesConfig;
